import React, { useState, useEffect,useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { updateFormData } from "../../redux/dispatch";
import useRubriqueNav from "../../hooks/useRubriqueNav";
import RubriqueNav from "../shared/RubriqueNav";
import TabEvolution from "./tabs/TabEvolution";
import TabConclusion from "./tabs/TabConclusion";
import "./PremiereHospitalisation.css";
import toast from 'react-hot-toast';
import { saveDossier } from "../../redux/dispatch";
import SaveLoader from "../shared/SaveLoader";
import { API_BASE } from "../../config/api";
import noImage from "../../assets/no-image.svg";
import { getPageConfidence } from "../dernieres_nouvelles/DernieresNouvelles";
const RUBRIQUE = "premiere_hospitalisation";


const EMPTY_EVOLUTION_PAGE = () => ({
  data:   "",
  poids:  "",
  taille: "",
  pb:     "",
  pc:     "",
  pn:     "",
  zscore: "",
});
const INITIAL_CONCLUSION = { data: "", date_prochain_rdv: "", motif: "" };

const TABS = [
  { id: "evolution",  label: "Évolution"   },
  { id: "conclusion", label: "Conclusion"  },
];

const PremiereHospitalisation = () => {
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const { id }   = useParams();
    const rawImages = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.images || []);
    const IMAGES = rawImages.length > 0
    ? rawImages.map((img) => `${API_BASE}/${img.chemin_image}`)
    : [noImage];
  const { currentDossier, list } = useSelector((s) => s.dossiers);
  const dossier = currentDossier || list.find((d) => d.id === id) || null;
  const source = useSelector((s) => s.formulaires.data?.[id]?._source);
  const formulairesData  = useSelector((s) => s.formulaires.data);
  const savedEvolution  = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.evolution  || [EMPTY_EVOLUTION_PAGE()]);
  const savedConclusion = useSelector((s) => s.formulaires.data?.[id]?.[RUBRIQUE]?.conclusion || INITIAL_CONCLUSION);
const [saving, setSaving] = useState(false);
  const [evolution,  setEvolution]  = useState(savedEvolution);
  const [conclusion, setConclusion] = useState({ ...INITIAL_CONCLUSION, ...savedConclusion });
  const [activeTab,  setActiveTab]  = useState("evolution");
  const [imgIndex,   setImgIndex]   = useState(0);
  const [activePage, setActivePage] = useState(0);
  const evolutionRef  = useRef(evolution);
  const conclusionRef = useRef(conclusion);

  useEffect(() => {
    setEvolution(savedEvolution);
    setConclusion({ ...INITIAL_CONCLUSION, ...savedConclusion });
  }, [id]);

    // AJOUTER après : const [activePage, setActivePage] = useState(0);
    useEffect(() => {
    setImgIndex(activePage < IMAGES.length ? activePage : IMAGES.length - 1);
    }, [activePage]);

    useEffect(() => { evolutionRef.current  = evolution;  }, [evolution]);
    useEffect(() => { conclusionRef.current = conclusion; }, [conclusion]);

// APRÈS
const { goNext, goPrev, goTo, suivante, precedente, indexCourant, total } = useRubriqueNav(RUBRIQUE);
    const getPaginationItems = (total, current) => {
        if (total <= 7) return Array.from({ length: total }, (_, i) => i);
        const items = [];
        items.push(0);
        if (current > 3) items.push("...");
        for (let i = Math.max(1, current - 1); i <= Math.min(total - 2, current + 1); i++) {
            items.push(i);
        }
        if (current < total - 4) items.push("...");
        items.push(total - 1);
        return items;
    };
  // ── Handlers Evolution ───────────────────────────────────────────────────────
  const handleChangePage = (pageIndex, html) => {
    setEvolution((prev) => {
      const updated = [...prev];
      updated[pageIndex] = { data: html };
      return updated;
    });
  };

    // APRÈS
    const handleAddPage = () => {
    setEvolution((prev) => [...prev, EMPTY_EVOLUTION_PAGE()]);
    setActivePage(evolution.length);
    };

  const handleDeletePage = (pageIndex) => {
    setEvolution((prev) => prev.filter((_, i) => i !== pageIndex));
  };

  // ── Handlers Conclusion ──────────────────────────────────────────────────────
  const handleChangeConclusion = (field, value) => {
    setConclusion((prev) => ({ ...prev, [field]: value }));
  };

  // ── Save / Cancel ────────────────────────────────────────────────────────────
    const handleSave = () => {
        dispatch(updateFormData(id, RUBRIQUE, "evolution",  evolutionRef.current));
        dispatch(updateFormData(id, RUBRIQUE, "conclusion", conclusionRef.current));
    };

    useEffect(() => {
      return () => {
        handleSave();
      };
    }, []);

   const handleSaveAll = async () => {
    setSaving(true);
    dispatch(updateFormData(id, RUBRIQUE, "evolution",  evolution));
    dispatch(updateFormData(id, RUBRIQUE, "conclusion", conclusion));
        try {
        const result = await dispatch(saveDossier());
        toast.success(result.message);
        navigate("/");
    } catch (err) {
        toast.error(err.response?.data?.message || "Erreur lors de la sauvegarde");
    }finally {
    setSaving(false);
  }
    
  };

  const handleCancel = () => {
    setEvolution(savedEvolution);
    setConclusion({ ...INITIAL_CONCLUSION, ...savedConclusion });
  };

  if (!dossier) {
    return (
      <div className="ph-no-dossier">
        <p>Aucun dossier sélectionné.</p>
        <button onClick={() => navigate("/")}>Retour à la liste</button>
      </div>
    );
  }

  return (
    <div className="ph-page">
      {/* ── Header ── */}
      <header className="ph-header">
         {saving && <SaveLoader />}
        <div className="ph-header-left">
          <button className="ph-back-btn" onClick={() => navigate("/")}>← Retour à la liste</button>
          <div>
            <h1 className="ph-title">Dossier {dossier.numero_dossier || dossier.id}</h1>
            <p className="ph-subtitle">Patient : {dossier.patient} &nbsp;|&nbsp; Service : {dossier.service}</p>
          </div>
        </div>
        <button className="ph-save-btn" onClick={handleSaveAll} disabled={saving}>Sauvegarder les modifications</button>
      </header>

      <div className="ph-body">
        {/* ── Colonne gauche : image ── */}
        <aside className="ph-image-panel">
          <div className="ph-image-header">
            <span className="ph-rubrique-label">Première Hospitalisation</span>
            <span className="ph-image-counter">Image {imgIndex + 1} / {IMAGES.length}</span>
          </div>
          <div className="ph-image-viewer">
            <img src={IMAGES[imgIndex]} alt={`Page ${imgIndex + 1}`} className="ph-image" />
          </div>

            <div className="ph-image-nav">
            <button className="ph-nav-btn" onClick={() => setImgIndex((i) => Math.max(0, i - 1))} disabled={imgIndex === 0}>‹</button>
            {getPaginationItems(IMAGES.length, imgIndex).map((item, i) =>
                item === "..." ? (
                <span key={i} className="ph-ellipsis">…</span>
                ) : (
                <button key={i}
                    className={`ph-nav-dot-btn ${imgIndex === item ? "ph-nav-dot-btn--active" : ""}`}
                    onClick={() => setImgIndex(item)}>
                    {item + 1}
                </button>
                )
            )}
            <button className="ph-nav-btn" onClick={() => setImgIndex((i) => Math.min(IMAGES.length - 1, i + 1))} disabled={imgIndex === IMAGES.length - 1}>›</button>
            </div>
        </aside>

        {/* ── Colonne droite : formulaire ── */}
        <main className="ph-form-panel">

          {/* ── Tabs ── */}
          <nav className="ph-tabs">
            {TABS.map((tab) => (
              <button
                key={tab.id}
                className={`ph-tab ${activeTab === tab.id ? "ph-tab--active" : ""}`}
                onClick={() => setActiveTab(tab.id)}
              >
                {tab.label}
              </button>
            ))}
          </nav>

          {/* ── Contenu ── */}
          <div className="ph-tab-content">
            {activeTab === "evolution" && (
           // APRÈS
                <TabEvolution
                    pages={evolution}
                    activePage={activePage}
                    setActivePage={setActivePage}
                    onChangePage={handleChangePage}
                    onAddPage={handleAddPage}
                    onDeletePage={handleDeletePage}
                    getPaginationItems={getPaginationItems}
                    onChangeField={(field, value) => {
                        setEvolution((prev) => {
                        const updated = [...prev];
                        updated[activePage] = { ...updated[activePage], [field]: value };
                        return updated;
                        });
                    }}
                    gc={(field) => getPageConfidence(evolution[activePage], field, source)}
                />
            )}
            {activeTab === "conclusion" && (
              <TabConclusion
                form={conclusion}
                onChange={handleChangeConclusion}
              />
            )}
          </div>

          {/* ── Actions ── */}
{/*           <div className="ph-form-actions">
            <button className="ph-btn-save" onClick={handleSave}>Enregistrer</button>
            <button className="ph-btn-cancel" onClick={handleCancel}>Annuler</button>
          </div> */}


<RubriqueNav goNext={goNext} goPrev={goPrev} goTo={goTo} suivante={suivante} precedente={precedente} indexCourant={indexCourant} total={total} />        </main>
      </div>
    </div>
  );
};

export default PremiereHospitalisation;